export const PROCUREMENT_STATUS = {
  COMMITTEE_ASSIGNED: "COMMITTEE_ASSIGNED",
  PURCHASE_DONE: "PURCHASE_DONE",
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
};

export const VENDOR_STATUS = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
};

export const STATUS = {
  ...PROCUREMENT_STATUS,
  ...VENDOR_STATUS,
};
